// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsApplicationsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsApplicationsWebApiHandler_acceptApplicationInvitation,
  CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord,
  CappsApplicationsWebApiHandler_startApplication,
  CappsApplicationsWebApiHandler_submitApplication,
  CappsApplicationsWebApiHandler_withdrawApplication,
  CappsApplicationsWebApiHandler_withdrawSharedApplication,
} from '@zg-rentals/ts-capps-client';

import type {
  AcceptApplicationInvitationWebApiRequestDto,
  AcceptApplicationInvitationWebApiResponseDto,
  ShareRentalApplicationWithLandlordWebApiRequestDto,
  StartApplicationWebApiRequestDto,
  StartApplicationWebApiResponseDto,
  SubmitApplicationWebApiRequestDto,
  WithdrawApplicationWebApiRequestDto,
  WithdrawSharedApplicationWebApiRequestDto,
} from '@zg-rentals/ts-capps-client';

export interface CappsApplicationsWebApiHandler_acceptApplicationInvitation_Args {
  postData: AcceptApplicationInvitationWebApiRequestDto;
}

export type CappsApplicationsWebApiHandler_acceptApplicationInvitation_Options = UseMutationOptions<
  AcceptApplicationInvitationWebApiResponseDto,
  unknown,
  CappsApplicationsWebApiHandler_acceptApplicationInvitation_Args
>;

export const useCappsApplicationsWebApiHandler_acceptApplicationInvitation = ({
  httpClient,
  ...options
}: Omit<CappsApplicationsWebApiHandler_acceptApplicationInvitation_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsApplicationsWebApiHandler_acceptApplicationInvitation_Args) =>
      CappsApplicationsWebApiHandler_acceptApplicationInvitation(args.postData, httpClient),
  });
};

export interface CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord_Args {
  postData: ShareRentalApplicationWithLandlordWebApiRequestDto;
}

export type CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord_Options = UseMutationOptions<
  void,
  unknown,
  CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord_Args
>;

export const useCappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord = ({
  httpClient,
  ...options
}: Omit<CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord_Args) =>
      CappsApplicationsWebApiHandler_shareRentalApplicationWithLandlord(args.postData, httpClient),
  });
};

export interface CappsApplicationsWebApiHandler_startApplication_Args {
  postData: StartApplicationWebApiRequestDto;
}

export type CappsApplicationsWebApiHandler_startApplication_Options = UseMutationOptions<
  StartApplicationWebApiResponseDto,
  unknown,
  CappsApplicationsWebApiHandler_startApplication_Args
>;

export const useCappsApplicationsWebApiHandler_startApplication = ({
  httpClient,
  ...options
}: Omit<CappsApplicationsWebApiHandler_startApplication_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsApplicationsWebApiHandler_startApplication_Args) =>
      CappsApplicationsWebApiHandler_startApplication(args.postData, httpClient),
  });
};

export interface CappsApplicationsWebApiHandler_submitApplication_Args {
  postData: SubmitApplicationWebApiRequestDto;
}

export type CappsApplicationsWebApiHandler_submitApplication_Options = UseMutationOptions<
  void,
  unknown,
  CappsApplicationsWebApiHandler_submitApplication_Args
>;

export const useCappsApplicationsWebApiHandler_submitApplication = ({
  httpClient,
  ...options
}: Omit<CappsApplicationsWebApiHandler_submitApplication_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsApplicationsWebApiHandler_submitApplication_Args) =>
      CappsApplicationsWebApiHandler_submitApplication(args.postData, httpClient),
  });
};

export interface CappsApplicationsWebApiHandler_withdrawApplication_Args {
  postData: WithdrawApplicationWebApiRequestDto;
}

export type CappsApplicationsWebApiHandler_withdrawApplication_Options = UseMutationOptions<
  void,
  unknown,
  CappsApplicationsWebApiHandler_withdrawApplication_Args
>;

export const useCappsApplicationsWebApiHandler_withdrawApplication = ({
  httpClient,
  ...options
}: Omit<CappsApplicationsWebApiHandler_withdrawApplication_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsApplicationsWebApiHandler_withdrawApplication_Args) =>
      CappsApplicationsWebApiHandler_withdrawApplication(args.postData, httpClient),
  });
};

export interface CappsApplicationsWebApiHandler_withdrawSharedApplication_Args {
  postData: WithdrawSharedApplicationWebApiRequestDto;
}

export type CappsApplicationsWebApiHandler_withdrawSharedApplication_Options = UseMutationOptions<
  void,
  unknown,
  CappsApplicationsWebApiHandler_withdrawSharedApplication_Args
>;

export const useCappsApplicationsWebApiHandler_withdrawSharedApplication = ({
  httpClient,
  ...options
}: Omit<CappsApplicationsWebApiHandler_withdrawSharedApplication_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsApplicationsWebApiHandler_withdrawSharedApplication_Args) =>
      CappsApplicationsWebApiHandler_withdrawSharedApplication(args.postData, httpClient),
  });
};
